import { BaseSidebarObject } from '@y42/gojs';
import { EMOJI_PROP } from './../../common/config/common-prop-names';

export class EmojiNode extends BaseSidebarObject {
  constructor(public key = '', public category = '', public location = '0 0', emoji = '') {
    super();
    this[EMOJI_PROP] = emoji;
  }

  [EMOJI_PROP]: string;
}
